import { instanceOf } from 'prop-types'
import cn from 'classnames'

import Settings from '../../../../models/settings.js'

export default function Banner({ settings }) {
  const {
    showBanner,
    showCardBanner,
    bannerLogoUrl,
    bannerHideLogoMobile,
    bannerBackgroundColor,
    bannerPadding,
    bannerPrimaryText,
    bannerPrimaryFontSize,
    bannerPrimaryColor,
    bannerSecondaryText,
    bannerSecondaryFontSize,
    bannerSecondaryColor,
  } = settings

  if (!showBanner || showCardBanner) {
    return null
  }

  const bannerStyles = {
    backgroundColor: bannerBackgroundColor,
    padding: bannerPadding,
  }

  const bannerTagline = bannerPrimaryText
  const bannerTaglineStyles = {
    fontSize: bannerPrimaryFontSize,
    color: bannerPrimaryColor,
  }

  const bannerTitle = bannerSecondaryText
  const bannerTitleStyles = {
    fontSize: bannerSecondaryFontSize,
    color: bannerSecondaryColor,
  }

  return (
    <div
      className={cn('bzfy-feed-banner', {
        'bzfy-feed-banner--hidelogo': bannerLogoUrl && bannerHideLogoMobile,
      })}
      style={bannerStyles}
    >
      <div>
        {bannerLogoUrl && (
          <img
            alt="Feed Banner"
            className="bzfy-feed-banner__logo"
            src={bannerLogoUrl}
            style={{
              left: bannerPadding,
            }}
          />
        )}
        {bannerTagline && (
          <p className="bzfy-feed-banner__tagline" id="banner-h1" style={bannerTaglineStyles}>
            {bannerTagline}
          </p>
        )}
        {bannerTitle && (
          <p id="banner-h2" style={bannerTitleStyles}>
            {bannerTitle}
          </p>
        )}
      </div>
    </div>
  )
}

Banner.propTypes = {
  settings: instanceOf(Settings).isRequired,
}
